import React, { useState } from 'react'

import { Tabs, Tab, Box } from '@mui/material'

import { Container } from '../../components'
import { useUser } from '../../hooks'
import { useOrganizationSummary } from '../../hooks/useSelfServeEntrataOnboard'
import { AddPropertyFormContainer } from './AddPropertyFormContainer'
import { RemovePropertyFormContainer } from './RemovePropertyFormContainer'
import { EntrataOnboardWizard } from './EntrataOnboardWizard/EntrataOnboardWizard'
import { SheetOnboardWizard } from './SheetOnboardWizard/SheetOnboardWizard'

export const EZFolioFormsRoot = () => {
    const { organization, rootUser, workspaceUser } = useUser()
    const { data: orgSummary, isFetched } = useOrganizationSummary(organization)
    const workspaceMatchesSelectedOrg =
        workspaceUser?.active_workspace?.organization === organization
    const workspaceFlag =
        workspaceUser?.active_workspace?.organization_entrata_enabled
    const knownFromWorkspace =
        workspaceMatchesSelectedOrg && workspaceFlag !== undefined
            ? Boolean(workspaceFlag)
            : undefined
    const entrataEnabled =
        orgSummary?.entrata_enabled ?? knownFromWorkspace ?? !isFetched

    const tabs = [
        ...(entrataEnabled
            ? [{ label: 'Onboard from Entrata', key: 'entrata' }]
            : []),
        { label: 'Onboard with Sheets', key: 'sheets' },
        { label: 'Add Property', key: 'add' },
        { label: 'Remove Property', key: 'remove' },
    ]

    const defaultKey = entrataEnabled ? 'entrata' : 'sheets'
    const [selectedKey, setSelectedKey] = useState<string | null>(null)
    const currentKey =
        selectedKey && tabs.some((tab) => tab.key === selectedKey)
            ? selectedKey
            : defaultKey

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        const next = tabs[newValue]
        if (next) {
            setSelectedKey(next.key)
        }
    }

    const activeTab = Math.max(
        0,
        tabs.findIndex((tab) => tab.key === currentKey),
    )

    return (
        <Container
            style={{ flex: 1, flexDirection: 'column', overflow: 'hidden' }}
        >
            <Box
                sx={{ borderBottom: 1, borderColor: 'divider', flexShrink: 0 }}
            >
                <Tabs value={activeTab} onChange={handleTabChange}>
                    {tabs.map((tab) => (
                        <Tab key={tab.key} label={tab.label} />
                    ))}
                </Tabs>
            </Box>

            {currentKey === 'entrata' && organization && (
                <EntrataOnboardWizard organization={organization} />
            )}
            {currentKey === 'sheets' && organization && (
                <SheetOnboardWizard organization={organization} />
            )}
            {currentKey === 'add' && (
                <AddPropertyFormContainer organization={organization} />
            )}
            {currentKey === 'remove' && rootUser && (
                <RemovePropertyFormContainer
                    rootUser={rootUser}
                    organization={organization}
                />
            )}
        </Container>
    )
}
